/* eslint-disable react/no-unused-prop-types */
import React from "react";

export interface TabProps {
  /** Is selected? */
  selected?: boolean;

  /** Used by parent renderer */
  label: string;
  disabled?: boolean;
  // Override value
  value?: number;
  count?: number;
  icon?: React.ReactNode;
}

/** Tab component. Doesn't do much apart from wrap info for parent <Tabs> component */
const Tab: React.FC<React.PropsWithChildren<TabProps>> = ({
  selected,
  children,
}) => {
  if (!selected) return null;

  return children;
};

export default Tab;
